// extracted by mini-css-extract-plugin
export default {"title":"LoginForm_title__arp9p","form":"LoginForm_form__xftlb","field":"LoginForm_field__UkYwS"};